import './ChoiceCard.css';
export default {
    "root": "ChoiceCard_root__fshrp",
    "clickable": "ChoiceCard_clickable__fshrp",
    "disabled": "ChoiceCard_disabled__fshrp",
    "selected": "ChoiceCard_selected__fshrp"
};
